/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateColumnPresetMutationRequest,
  UpdateColumnPresetMutationResponse,
  UpdateColumnPresetPathParams,
} from '../types/UpdateColumnPreset'

function getUpdateColumnPresetUrl({
  id,
}: {
  id: UpdateColumnPresetPathParams['id']
}) {
  const res = { method: 'PATCH', url: `/api/v1/column-presets/${id}/` as const }
  return res
}

/**
 * @summary Update name or shared flag on a column preset
 * {@link /api/v1/column-presets/:id/}
 */
export async function updateColumnPreset(
  { id }: { id: UpdateColumnPresetPathParams['id'] },
  data?: UpdateColumnPresetMutationRequest,
  config: Partial<RequestConfig<UpdateColumnPresetMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateColumnPresetMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateColumnPresetMutationRequest
  >({
    method: 'PATCH',
    url: getUpdateColumnPresetUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
